export const SETPAGEHEADING = "SETPAGEHEADING";